
























































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { masterModule } from '@/store/modules/entities/master.module';
import GExamCreateDetailSetting from '@/views/GExamCreate/QuestionSetting/GExamCreateQuestionSettingDetail.vue';
import GExamCreateConfirmView from '@/views/GExamCreate/ConfirmView/GExamCreateConfirmView.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { GEnum } from '@/constants/enum.defination';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { GPageBase } from '@/mixins';
import GExamDetailProgress from '@/views/GExamDetail/GExamDetailProgress.vue';
import GExamDetailReportSetting from '@/views/GExamDetail/GExamDetailReportSetting.vue';
import GExamDetailEvalRequestSetting from '@/views/GExamDetail/GExamDetailEvalRequestSetting.vue';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import GLoading from '@/components/GLoading.vue';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { TeacherSearch } from '@/models/teacher/teacher-search';

@Component({
  name: 'GExamDetail',
  components: {
    GExamDetailEvalRequestSetting,
    GExamDetailReportSetting,
    GExamDetailProgress,
    GTitleBar,
    GCustomBreadCrumb,
    GExamCreateConfirmView,
    GExamCreateDetailSetting,
    GLoading,
  },
  computed: {},
  methods: {},
})
export default class GExamDetail extends mixins(GPageBase) {
  evalSettingID: number = 0; // クエリパラメータから取得した受検コースID
  breadCrumbItems: BreadCrumbElement[] = []; // パンくずリスト
  lazy: boolean = false; // 遅延描画用(リソース取得後にmount)
  isModal: boolean = false; // 受検未割り当て者の更新を促すダイアログ

  created() {
    this.evalSettingID = Number(this.$route.params['evalSettingID']);
    const mode = Number(this.$route.query['mode']);
    examCreateModule.setMode(mode);
  }
  async mounted() {
    examCreateModule.clean();
    evalSettingDetailModule.clean();
    await evalSettingModule.fetchEvalSettingDetail(this.evalSettingID);
    await evalSettingDetailModule.setGrowCourseScoreUpdateStatus(this.evalSettingID);
    const examSelectionType: GEnum.ExamineeSelectionType = this.evalSettingDetail.schoolClasses.length > 0 ? GEnum.ExamineeSelectionType.Class : GEnum.ExamineeSelectionType.Student;
    examCreateModule.setExamnieeSelectionType(examSelectionType);

    this.breadCrumbItems = [
      { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' },
      { title: this.$t('MENU_EVAL_COURSE').toString(), routerPath: '/pages/exam/list' },
      { title: this.$t('EXAM_DETAIL').toString() + `【${this.evalSettingDetail.title}】` },
    ];
    await masterModule.fetchQuestionType();
    await masterModule.fetchAllQuestionType();
    masterModule.fetchCompetency();
    // 傾向チェックマスタデータ取得
    masterModule.fetchTrends();
    // 受検設定周りの情報取得
    await schoolClassModule.fetchGrades();
    await schoolClassModule.fetchSchoolClasses();
    await schoolClassModule.fetchGradesSchoolClasses();
    await evalSettingDetailModule.fetchExamineeStudentProgresses(this.evalSettingDetail.evalSettingID);
    examCreateModule.setCompetencySelections(this.evalSettingDetail.competencyIDs.map((competencyID: number) => masterModule.toCompetency(competencyID)));
    examCreateModule.setExamineeStudents(this.evalSettingDetail.students);

    // メール設定用に先生一覧を取得
    teacherModule.fetchTeacherList({} as TeacherSearch);

    this.lazy = true;

    setTimeout(() => {
      if (this.evalSettingDetail.noAssignedExamineeCount > 0 && this.evalSettingDetail.isBeforeEnd) {
        this.isModal = true;
      }
    }, 1000);
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get isBeforeEnd(): boolean {
    return evalSettingModule.evalSettingDetail.isBeforeEnd;
  }

  get isDownloadProgressRunning(): boolean {
    return evalSettingDetailModule.isDownloadProgressRunning;
  }

  handleUpdateExamineeStudents() {
    this.loadingPage(
      () => {
        evalSettingModule.updateExamineeStudents(this.evalSettingID);
      },
      () => {
        this.showNotice(GEnum.MessageType.Success, this.$t('EVAL_COURSE').toString() + `【${this.evalSettingDetail.title}】`, this.$t('EVAL_COURSE_UPDATE_STUDENTS').toString());
        this.isModal = false;
      }
    );
  }

  handleGotoExamEdit() {
    this.$router.push(`/pages/exam/create?mode=${GEnum.EvalSettingMode.Edit}&evalSettingID=${this.evalSettingID}`);
  }
}
